import { Component } from 'preact'
import { IdeaStatus } from '../../control-components/ideation-status/Types'
import IdeationColumn from './pipeline/IdeationColumn'
import { Idea } from './Types'
import axios from 'axios'
import WidgetContainer from '../widget-container'
import { CurrentUserContext } from '../../server-middleware/userContext'

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export type IdeationPipelineConfig = {
  title?: string
  subtitle?: string
  backgroundColor?: string
  backgroundColorDisplay?: 'solid_color' | 'none'

  column_1: number
  column_2: number
  column_3: number
  maxHeight: number
}

export interface IdeationPipelineProps extends IdeationPipelineConfig {
  onChange: (state: { title: string }) => void
}

interface State {
  ideaStatusList: IdeaStatus[]
  ideasFirstCol: {
    topics: Idea[]
    totalTopicCount: number
  }
  ideasSecondCol: {
    topics: Idea[]
    totalTopicCount: number
  }
  ideasThirdCol: {
    topics: Idea[]
    totalTopicCount: number
  }
}

class IdeationPipeline extends Component<IdeationPipelineProps, State> {
  constructor(props: IdeationPipelineProps) {
    super(props)

    this.state = {
      ideaStatusList: [],
      ideasFirstCol: {
        topics: [],
        totalTopicCount: 0
      },
      ideasSecondCol: {
        topics: [],
        totalTopicCount: 0
      },
      ideasThirdCol: {
        topics: [],
        totalTopicCount: 0
      }
    }
  }

  getIdeationStatusTitle(ideaStatusId: number) {
    const items: IdeaStatus[] = this.state.ideaStatusList.filter(
      (status: IdeaStatus) => status.id === ideaStatusId.toString()
    )

    if (!items.length) return ''

    return items[0].name
  }

  async getIdeasByIdeationStatus(ideaStatusName: string) {
    const filters = { ideationStatus: [ideaStatusName] }

    const res = await axios.get('/ideas/topics', {
      params: {
        filters,
        sort: {
          votes: 'desc'
        }
      }
    })

    if (res.data) {
      return res.data
    }
    return {
      ideas: [],
      totalTopicCount: 0
    }
  }

  async componentDidMount() {
    const { data } = await axios.get('/community/api/ideas/ideaStatuses')
    if (!data.result.length) {
      return
    }

    this.setState({ ideaStatusList: data.result })

    const titleFirstColumn = this.getIdeationStatusTitle(this.props.column_1)
    const ideasFirst = await this.getIdeasByIdeationStatus(titleFirstColumn)

    const titleSecondColumn = this.getIdeationStatusTitle(this.props.column_2)
    const ideasSec = await this.getIdeasByIdeationStatus(titleSecondColumn)

    const titleThirdColumn = this.getIdeationStatusTitle(this.props.column_3)
    const ideasThird = await this.getIdeasByIdeationStatus(titleThirdColumn)

    this.setState({
      ideasFirstCol: ideasFirst,
      ideasSecondCol: ideasSec,
      ideasThirdCol: ideasThird
    })
  }

  render() {
    const { title, subtitle, backgroundColor, backgroundColorDisplay, maxHeight } = this.props
    const { ideasFirstCol, ideasSecondCol, ideasThirdCol } = this.state
    return (
      <CurrentUserContext.Consumer>
        {(user) => (
          <WidgetContainer
            config={{ title, subtitle, backgroundColor, backgroundColorDisplay }}
            widgetName='pipeline__widget'
          >
            <div className='pipeline-col-list' style={{ 'max-height': maxHeight }}>
              <IdeationColumn
                ideaStatusTitle={this.getIdeationStatusTitle(this.props.column_1)}
                ideaList={ideasFirstCol.topics}
                totalTopicCount={ideasFirstCol.totalTopicCount}
                maxHeight={maxHeight}
                currentUserId={user.id}
              />
              <IdeationColumn
                ideaStatusTitle={this.getIdeationStatusTitle(this.props.column_2)}
                ideaList={ideasSecondCol.topics}
                totalTopicCount={ideasSecondCol.totalTopicCount}
                maxHeight={maxHeight}
                currentUserId={user.id}
              />
              <IdeationColumn
                ideaStatusTitle={this.getIdeationStatusTitle(this.props.column_3)}
                ideaList={ideasThirdCol.topics}
                totalTopicCount={ideasThirdCol.totalTopicCount}
                maxHeight={maxHeight}
                currentUserId={user.id}
              />
            </div>
          </WidgetContainer>
        )}
      </CurrentUserContext.Consumer>
    )
  }
}

export default IdeationPipeline
